import { defineMessages } from 'react-intl';

export default defineMessages({
  registerSuccessMessage: {
    id: 'employee.form.alert.registerSuccess',
    defaultMessage: 'Registrasi Employee Sukses',
  },
  editSuccessMessage: {
    id: 'employee.form.alert.editSuccessMessage',
    defaultMessage: 'Edit Employee Sukses',
  },
  btnEdit: {
    id: 'employee.form.btn.edit',
    defaultMessage: 'Simpan',
  },
  btnRegister: {
    id: 'employee.form.btn.registerEmployee',
    defaultMessage: 'Register Employee',
  },
  breadcrumbRegister: {
    id: 'employee.breadcrumb.register',
    defaultMessage: 'Register New Employee',
  },
  breadcrumbEdit: {
    id: 'employee.breadcrumb.edit',
    defaultMessage: 'Edit Employee',
  },
  breadcrumbList: {
    id: 'employee.list',
    defaultMessage: 'Employee List',
  },
  formRequiredPassword: {
    id: 'employee.form.warning.required.password',
    defaultMessage: 'Password wajib di isi',
  },
  formLeftTitle: {
    id: 'employee.form.left.title',
    defaultMessage: 'Register New Employee',
  },
  editTitle: {
    id: 'employee.form.title.edit',
    defaultMessage: 'Edit Employee',
  },
  formLabelEmployeeName: {
    id: 'employee.form.label.employeeName',
    defaultMessage: 'Employee Name',
  },
  formRequiredEmployeeName: {
    id: 'employee.form.warning.required.employeeName',
    defaultMessage: 'Nama Employee wajib di isi',
  },
  formPlaceholderEmployeeName: {
    id: 'employee.form.placeholder.employeeName',
    defaultMessage: 'Masukkan nama employee',
  },
  formLabelPhotoEmployee: {
    id: 'employee.form.label.photoEmployee',
    defaultMessage: 'Photo',
  },
  formRequiredPhotoEmployee: {
    id: 'employee.form.warning.required.photoEmployee',
    defaultMessage: 'Foto karyawan wajib di isi',
  },
  formBtnPhotoEmployee: {
    id: 'employee.form.btn.photo',
    defaultMessage: 'Upload Photo',
  },
  formLabelEmployeeKtp: {
    id: 'employee.form.label.employeeKtp',
    defaultMessage: 'Employee ID Card (KTP) Number',
  },
  formRequiredEmployeeKtp: {
    id: 'employee.form.warning.required.employeeKtp',
    defaultMessage: 'Nomor KTP wajib di isi',
  },
  formMaximumEmployeeKtp: {
    id: 'employee.form.warning.maximum.employeeKtp',
    defaultMessage: 'Maksimal 20 Numeric',
  },
  formPlaceholderEmployeeKtp: {
    id: 'employee.form.placeholder.employeeKtp',
    defaultMessage: 'Masukkan nomor ktp',
  },
  formRightTitle: {
    id: 'employee.form.right.title',
    defaultMessage: 'User Login',
  },
  formLabelEmployeeEmail: {
    id: 'employee.form.label.employeeEmail',
    defaultMessage: 'Employee Email',
  },
  formRequiredEmployeeEmail: {
    id: 'employee.form.warning.required.employeeEmail',
    defaultMessage: 'Email wajib di isi',
  },
  formInvalidEmployeeEmail: {
    id: 'employee.form.warning.invalid.employeeEmail',
    defaultMessage: 'Format email salah',
  },
  formPlaceholderEmployeeEmail: {
    id: 'employee.form.placeholder.employeeEmail',
    defaultMessage: 'Masukkan email',
  },
  formLabelEmployeePassword: {
    id: 'employee.form.label.employeePassword',
    defaultMessage: 'Employee Password',
  },
  formInvalidEmployeePassword: {
    id: 'employee.form.warning.invalid.employeePassword',
    defaultMessage:
      'Kata sandi setidaknya terdiri dari satu angka, satu huruf kecil, satu huruf besar dan 8-16 karakter',
  },
  formPlaceholderEmployeePassword: {
    id: 'employee.form.placeholder.employeePassword',
    defaultMessage: 'Masukkan password',
  },
  formLabelEmployeePhone: {
    id: 'employee.form.label.employeePhone',
    defaultMessage: 'Employee Phone Number',
  },
  formRequiredEmployeePhone: {
    id: 'employee.form.warning.required.employeePhone',
    defaultMessage: 'Employee phone required',
  },
  formPlaceholderEmployeePhone: {
    id: 'employee.form.placeholder.employeePhone',
    defaultMessage: 'Your employee phone number',
  },
  formLabelAvailableEmployeeRoles: {
    id: 'company.form.label.availableEmployeeRoles',
    defaultMessage: 'Available Employee Roles',
  },
  formRequiredEmployeeRoles: {
    id: 'company.form.warning.required.employeeRoles',
    defaultMessage: 'Employee role wajib dipilih',
  },
  createNewEmployeeSuccessDescription: {
    id: 'employee.form.create.success.description',
    defaultMessage: 'Finished registering your employee',
  },
  updateEmployeeSuccessDescription: {
    id: 'employee.form.update.success.description',
    defaultMessage: 'Finished updating your employee',
  },
  rollbackConfirmationTitle: {
    id: 'employee.modal.rollback.confirm.title',
    defaultMessage: 'Confirmation',
  },
  rollbackConfirmationDescription: {
    id: 'employee.modal.rollback.confirm.description',
    defaultMessage: 'Are you sure want to cancel registering progress?',
  },
  rollbackConfirmationBtnOk: {
    id: 'employee.modal.rollback.confirm.btn.ok',
    defaultMessage: 'Yes',
  },
  rollbackConfirmationBtnCancel: {
    id: 'employee.modal.rollback.confirm.btn.cancel',
    defaultMessage: 'No',
  },
  rollbackSuccessTitle: {
    id: 'employee.modal.rollback.success.title',
    defaultMessage: 'Success',
  },
  rollbackSuccessDescription: {
    id: 'employee.modal.rollback.success.description',
    defaultMessage: 'Rollback success',
  },
  rollbackSuccessBtnOk: {
    id: 'employee.modal.rollback.success.btn.ok',
    defaultMessage: 'Ok',
  },
  rollbackErrorTitle: {
    id: 'employee.modal.rollback.error.title',
    defaultMessage: 'Error',
  },
  rollbackErrorDescription: {
    id: 'employee.modal.rollback.error.description',
    defaultMessage: 'Rollback error, please try again',
  },
  rollbackErrorBtnRetry: {
    id: 'employee.modal.rollback.error.btn.retry',
    defaultMessage: 'Retry',
  },
  updateEmployeeErrorDescription: {
    id: 'employee.form.update.error.description',
    defaultMessage: 'Update failed',
  },
  employeeFormInvalidPhone: {
    id: 'employee.form.validation.phone',
    defaultMessage: 'Start with +62|62|08, number only, min length 9 max 13',
  },
  employeeFormInvalidNationalID: {
    id: 'employee.form.validation.nationalID',
    defaultMessage: 'National Id must be number only',
  },
  employeeFormWarnSelectRole: {
    id: 'employee.form.warning.selectRole',
    defaultMessage: 'Select employee roles first',
  },
  employeeFormCreateSubmittingTitle: {
    id: 'employee.form.create.submitting.title',
    defaultMessage: 'Registering...',
  },
  employeeFormUpdateSubmittingTitle: {
    id: 'employee.form.update.submitting.title',
    defaultMessage: 'Updating...',
  },
  employeeFormCreateRetryTitle: {
    id: 'employee.form.create.retry.title',
    defaultMessage: 'Retry Registering Employee',
  },
  employeeFormUpdateRetryTitle: {
    id: 'employee.form.update.retry.title',
    defaultMessage: 'Retry Updating Employee',
  },
  employeeFormCreateRemarksErrorTitle: {
    id: 'employee.form.create.remarks.error.title',
    defaultMessage: 'Registering Failed',
  },
  employeeFormUpdateRemarksErrorTitle: {
    id: 'employee.form.update.remarks.error.title',
    defaultMessage: 'Updating Failed',
  },
  employeeFormCreateRemarksErrorDescription: {
    id: 'employee.form.create.remarks.error.description',
    defaultMessage: 'There is an error when registering your employee',
  },
  employeeFormUpdateRemarksErrorDescription: {
    id: 'employee.form.update.remarks.error.description',
    defaultMessage: 'There is an error when updating your employee',
  },
  employeeFormCreateRemarksSuccessTitle: {
    id: 'employee.form.create.remarks.success.title',
    defaultMessage: 'Registering Success',
  },
  employeeFormUpdateRemarksSuccessTitle: {
    id: 'employee.form.update.remarks.success.title',
    defaultMessage: 'Updating Success',
  },
  employeeFormCreateRemarksSuccessDescription: {
    id: 'employee.form.create.remarks.success.description',
    defaultMessage: 'Success registering your employee',
  },
  employeeFormUpdateRemarksSuccessDescription: {
    id: 'employee.form.update.remarks.success.description',
    defaultMessage: 'Success updating your employee',
  },
  employeeFormCreateRemarksSuccessSubDescription: {
    id: 'employee.form.create.remarks.success.subDescription',
    defaultMessage:
      'You can register another employee or go back to employee list',
  },
  employeeFormCreateRemarksCreateAnother: {
    id: 'employee.form.create.remarks.createAnother',
    defaultMessage: 'Register Another Employee',
  },
  employeeFormUpdateUserTitle: {
    id: 'employee.form.update.user.title',
    defaultMessage: 'Updating user account',
  },
  employeeFormUpdateEmployeeTitle: {
    id: 'employee.form.update.employee.title',
    defaultMessage: 'Updating your employee',
  },
  employeeFormCreateUserTitle: {
    id: 'employee.form.create.user.title',
    defaultMessage: 'Creating user account',
  },
  employeeFormCreateEmployeeTitle: {
    id: 'employee.form.create.employee.title',
    defaultMessage: 'Registering your employee',
  },
  employeeStepOneTitle: {
    id: 'headerSteps.employee.stepOne.title',
    defaultMessage: 'Pendaftaran Karyawan',
  },
  employeeStepOneDescription: {
    id: 'headerSteps.employee.stepOne.description',
    defaultMessage: 'Proses pendaftaran data untuk karyawan baru',
  },
  employeeStepTwoTitle: {
    id: 'headerSteps.employee.stepTwo.title',
    defaultMessage: 'Proses Pengaturan Karyawan',
  },
  employeeStepTwoDescription: {
    id: 'headerSteps.employee.stepTwo.description',
    defaultMessage: 'Proses pemberian peran dan izin untuk karyawan',
  },
  employeeStepThreeTitle: {
    id: 'headerSteps.employee.stepThree.title',
    defaultMessage: 'Proses Upload Data',
  },
  employeeStepThreeDescription: {
    id: 'headerSteps.employee.stepThree.description',
    defaultMessage: 'Proses penguploadan data untuk registrasi karyawan',
  },
});
